// eslint-disable-next-line @typescript-eslint/no-empty-function
// eslint-disable-next-line no-console
import { datadogRum } from "@datadog/browser-rum";
import axios from "axios";

export interface DatadogEnvVariables {
    readonly applicationId: string;
    readonly clientToken: string;
    readonly environment: string;
}

export const initializeDatadogRum = async () => {
    await axios
        .get<DatadogEnvVariables>("/cart/datadogenvvariables")
        .then((response) => {
            const { applicationId, clientToken, environment } = response.data;

            datadogRum.init({
                applicationId: applicationId,
                clientToken: clientToken,
                site: "datadoghq.com",
                service: "hostedcart-client-app",
                env: environment,
                sessionSampleRate: 100,
                sessionReplaySampleRate: 30,
                trackUserInteractions: true,
                trackResources: true,
                trackLongTasks: true,
                defaultPrivacyLevel: "mask-user-input",
                trackViewsManually: false,
            });
            datadogRum.setGlobalContextProperty("PartnerDomain", window.location.host);
            datadogRum.startSessionReplayRecording();
        })
        .catch((error) => {
            console.error("Failed to initialize Datadog RUM:", error);
        });
}